__turbopack_context__.v({
  "userSuggestionTitle": "uVxSeW_userSuggestionTitle",
});
